import { render, staticRenderFns } from "./CategorySlider.vue?vue&type=template&id=211ac08c"
import script from "./CategorySlider.vue?vue&type=script&lang=js"
export * from "./CategorySlider.vue?vue&type=script&lang=js"
import style0 from "./CategorySlider.vue?vue&type=style&index=0&id=211ac08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports